import { Document } from '@roc/feature-types';
import { DOCUMENT_FORMS, CLOSING_CONDITION, BANK_STATEMENT_PREFIX, LEASE_INFORMATION_UNIT_PREFIX, TAX_ESCROW, POST_DISASTER_INSPECTION, TRIMERGE_CREDIT_REPORT, CREDIT_REPORT, BANK_STATEMENT_MONTH_PREFIX, PROPERTY_RESOLUTION, BORROWER_RESOLUTION, LEASE_AGREEMENT_PREFIX, BANK_STATEMENT_TASK_CODE, AUTOMATED_DOC_REVIEW_FORMS } from '../constants';
import { TaskStatus, TaskStatusDB } from '@roc/feature-general-tasks';

export const isAccepted = (document: Document) => {
  return document && (document.status === TaskStatusDB.ACCEPTED || document.status === TaskStatus.ACCEPTED);
};

export const isPendingOrMoreInfoNeeded = (document: Document) => {
  return document && (
    document.status === TaskStatusDB.PENDING || document.status === TaskStatusDB.MORE_INFO_NEEDED ||
    document.status === TaskStatus.PENDING || document.status === TaskStatus.MORE_INFO_NEEDED
  );
};


export const isFileAlreadyUploaded = (document: Document) => {
  return document && !!document.dropboxPath;
};

export const isFormDocument = (document: Document, isNportalUser: boolean, toDosFrameworkEnabled: boolean) => {
  return document && !!DOCUMENT_FORMS[document.taskName] || (document.taskName && (document.taskName.includes(BORROWER_RESOLUTION) || document.taskName.includes(PROPERTY_RESOLUTION))) || (document.taskName && document.taskName.includes(CLOSING_CONDITION)) || (document.taskName && document.taskName.startsWith(LEASE_INFORMATION_UNIT_PREFIX)) || (isNportalUser && document.taskName && (document.taskName === TAX_ESCROW || document.taskName === POST_DISASTER_INSPECTION))
    || (!toDosFrameworkEnabled && (document.taskName === TRIMERGE_CREDIT_REPORT || document.taskName === CREDIT_REPORT)) ||
    !!document?.resolutionType || !!AUTOMATED_DOC_REVIEW_FORMS[document.taskName];
};

export const documentIsUploadAllowedOnly = (
  isUploadAllowedOnly: string[],
  document: Document
) => {
  return (
    isUploadAllowedOnly && isUploadAllowedOnly.includes(document.taskName)
  );
};

export const documentUploadNotAllowedOnly = (
  isUploadNotAllowedOnly: string[],
  document: Document
) => {
  return (
    isUploadNotAllowedOnly &&
    isUploadNotAllowedOnly.includes(document.taskName)
  );
};

export const documentUploadAllowedForSection = (
  isUploadAllowedForSection: string[],
  document: Document
) => {
  return (
    isUploadAllowedForSection && isUploadAllowedForSection.includes(document.sectionName)
  );
};
